/**
 * Menu Type Definitions
 *
 * This file contains TypeScript interfaces and constants for menu routes and related data structures.
 */

/**
 * Menu type enumeration constant
 */
export const MenuTypeConst = {
  MAIN: "MAIN",
  ADMIN: "ADMIN",
  ALL: "ALL",
} as const;

/**
 * Menu type values - "MAIN" | "ADMIN" | "ALL"
 */
export type MenuType = typeof MenuTypeConst[keyof typeof MenuTypeConst];

/**
 * Represents a single menu route item
 */
export interface MenuRoute {
  to?: string;
  layout?: string;
  name?: React.ReactNode;
  view?: boolean;
  subPages?: string[];
  isForceAvailableMenu?: boolean;
  collapse?: boolean;
  state?: string;
  icon?: React.ReactNode;
  views?: MenuRoute[];
  isLabFeature?: boolean;
}

/**
 * Default path object with pathname and search params
 */
export interface DefaultPath {
  pathname: string;
  search: string;
}

/**
 * Return type of useAvailibleMenu hook
 */
export interface AvailibleMenuData {
  routes?: MenuRoute[];
  availableMenuPaths: Record<string, MenuRoute>;
  forceMenuPaths?: Record<string, MenuRoute>;
  allPaths: Record<string, MenuRoute>;
  defaultPath: DefaultPath | string;
  isAdminMenuAvailable?: boolean;
}

/**
 * Default export for backwards compatibility with JavaScript files
 */
export default MenuTypeConst;
